import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    quests: [],
    cult: null,
    page: 1,
    page_size: 10,
    total: 0,
    page_count: 0,
    order_column: 'id',
    order_type: 'desc'
  },

  mutations: {
    setQuests(state, payload) {
      state.quests = payload
    },
    setCult(state, payload) {
      state.cult = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setTotal(state, payload) {
      state.total = payload
    },
    setPageCount(state, payload) {
      state.page_count = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    reset(state) {
      state.quests = []
      state.cult = null
      state.page = 1
      state.page_size = 10
      state.total = 0
      state.page_count = 0
      state.order_column = 'id'
      state.order_type = 'desc'
      state.loading = false
    }
  },

  actions: {
    readQuests({ commit, state }, cult_id) {
      commit('setLoading', true)
      axios.admin
        .get(`/web3/cults/${cult_id}/quests`, {
          params: {
            page: state.page,
            perPage: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          if (r.data.quests) {
            commit('setCult', r.data.cult)
            commit('setQuests', r.data.quests.data)
            commit('setTotal', r.data.quests.total)
            commit('setPageCount', r.data.quests.last_page)
          } else {
            commit('setQuests', r.data.data)
            commit('setTotal', r.data.total)
            commit('setPageCount', r.data.last_page)
          }
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    /**
     * Pick winners for a quest
     * @param {Object} dispatch - The dispatch function
     * @param {Object} payload - The payload containing the questId and cultId
     * @returns {Promise<void>}
     */
    async pickWinners({ dispatch }, payload) {
      try {
        await axios.admin.post(`/web3/quests/${payload.questId}/pick-winners`)

        dispatch('readQuests', payload.cultId)
      } catch (err) {
        console.error(err)
      }
    }
  },

  getters: {
    getQuests(state) {
      return state.quests
    },
    getCult(state) {
      return state.cult
    }
  }
}
